import { useUserDevices } from './useUserDevices';

export function usePrimaryDevice() {
  const { devices, loading, error } = useUserDevices();
  
  const primaryDevice = devices.find(d => d.is_primary) || devices[0] || null;

  // NOTE: localStorage sync hanteras nu centralt av deviceStateManager i HomePage
  // för att undvika duplicerad logik och race conditions

  return {
    primaryDevice: primaryDevice ? {
      id: primaryDevice.device_id,
      name: primaryDevice.device_name,
      code: primaryDevice.device_code
    } : null,
    loading,
    error
  };
}
